import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, FormGroup, Label, Input, Button, CustomInput } from "reactstrap"
import Cargando from 'components/Varios/Cargando'
import IconCloseModal from 'components/Varios/Modals/IconCloseModal'
import { FileInfo, FileInfoUrl } from 'Types/GeneralTypes'
import InputFileUpload from './InputFileUpload'

type PropsModalFirmarPDF = {
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    onClose: () => void,
    cargandoDatos: boolean,
    onClickSubirDocFirmaElectronica?: (objeto: ObjetoSubirDocumento) => Promise<void>,
    onClickFirmaFisica?:(objeto:ObjetoSubirDocumento) => Promise<void>,
    tituloModal: string,
    extraData?: any,
    admiteFirmaFisica: boolean,
    contentClassName?:string
    soloTipoFirma?: string //DEBERIAN SER E O F
}

type TipoFirma = "E" | "F" //"Electronica(Digital) o Fisica"


type stateModalFirmar = {
    filesEnviar: FileInfoUrl[],
    subiendoDocumento: boolean,
   // tipoFirma: TipoFirma 

}

export type ObjetoSubirDocumento = {
    extraData?:any,
    filesEnviar:FileInfoUrl[],
    tipoFirma:TipoFirma
}




export default function ModalSubirDocumentoFirmado(props: PropsModalFirmarPDF) {






    const stateInicial: stateModalFirmar = {
        filesEnviar: [],
        subiendoDocumento: false,
        //tipoFirma: tpFirma === "E" ? "E":"F",
      
    }


    useEffect(() => {


        if (props.soloTipoFirma) {
            settipoFirma(props.soloTipoFirma)
        }
        



    }, [props.soloTipoFirma])



   
    const [stateModal, setstateModalFirmar] = useState<stateModalFirmar>(stateInicial)
    const [tipoFirma, settipoFirma] = useState<string|undefined>(undefined)
    


    const ButtonAcept = useRef<HTMLButtonElement>();

    const ContenidoModalBody = useMemo(() => {
        if (props.cargandoDatos) {
            return (
                <Cargando />
            )
        }
        else if (!props.cargandoDatos) {

            const mostrarOpcionElectronica = tipoFirma === "E" || tipoFirma === undefined || props.soloTipoFirma === undefined
            var classNameElectronica = tipoFirma === "E" ? "col-12 text-center" : "col-md-3 col-sm-6 text-center"

            

            const mostrarOpcionFisica = tipoFirma === "F" || tipoFirma === undefined || props.soloTipoFirma === undefined
            var classNameFisica = tipoFirma === "F" ? "col-12 text-center" : "col-md-3 col-sm-6 text-center"


            if (props.soloTipoFirma === undefined) {
                classNameElectronica = "col-md-3 col-sm-6 text-center"
                classNameFisica = "col-md-3 col-sm-6 text-center"
            }

            return (
                <React.Fragment>
                   
                    <Row className="justify-content-center">

                        {
                            mostrarOpcionElectronica && 
                            <CustomInput
                                className={classNameElectronica}
                                type="radio"
                                checked={tipoFirma === "E"}
                                id="firmaElectronica1"
                                onChange={() =>settipoFirma("E")}
                                label="Subir con firma electrónica"
                            />

                        }

                        {
                            mostrarOpcionFisica &&
                            <CustomInput
                                className={classNameFisica}
                                type="radio"
                                id="firmaElectronica2"
                                checked={tipoFirma === "F"}
                                onChange={() => settipoFirma("F")}
                                label="Subir con firma física"
                                disabled={!props.admiteFirmaFisica}
                            />
                        }

                    </Row>
                    {
                        tipoFirma === "E" &&
                        <Row form className="mt-3">
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="nombremencion">Documento Firmado Electrónicamente*</Label>
                                    <InputFileUpload
                                        icon="upload"
                                        onChange={(archivo: FileInfo) => handleFileUploadChange(archivo)}
                                        name="DOC"
                                        id="CERT"
                                        placeholder="Subir documento"
                                    />
                                </FormGroup>
                            </Col>
                           
                        </Row>
                    }
                    {
                       tipoFirma === "F" && props.admiteFirmaFisica &&
                        <React.Fragment>
                            <Row className="ml-2 mt-2">
                                <span id="muted">
                                <i className="fas fa-info-circle pr-2" aria-hidden="true" style={{ color: "red" }}></i >
                                    Esta solicitud se hará efectiva, una vez que se entregue el documento original firmado en la Dirección de Talento Humano
                                    
                                </span>
                            </Row>
                            <Row form className="mt-3">
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="nombremencion">Documento Firmado Físicamente*</Label>
                                    <InputFileUpload
                                        icon="upload"
                                        onChange={(archivo: FileInfo) => handleFileUploadChange(archivo)}
                                        name="DOC"
                                        id="CERT"
                                        placeholder="Subir documento"
                                    />
                                </FormGroup>
                            </Col>
                           
                        </Row>
                            
                        </React.Fragment>
                    }
                </React.Fragment>


            )
        }
        else {
            return (
                <div>
                    No hay contenido por mostrar
                </div>
            )
        }
    }, [props.cargandoDatos, stateModal, tipoFirma])

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal
                handleClickIcon={() => CerrarModal()}
            />
        )
    }
        , [props])

    const BotonFirmar = useMemo(() => {
        const { subiendoDocumento, filesEnviar } = stateModal
        var objeto_pasando: ObjetoSubirDocumento = {
            extraData: props.extraData,
            filesEnviar,
            tipoFirma: tipoFirma === "E" ? "E" : "F"
        }

        var nombreAccion = "Enviar"

        const botonAceptar = document.getElementById("botonAceptar");
        const i_element = document.getElementById("loadingEnviar");

        if (subiendoDocumento && botonAceptar !== null && filesEnviar.length > 0 ) {
            const i = document.createElement("i");
            i.setAttribute("id", "loadingEnviar")
            i.setAttribute("class", "fa fa-spin fa-spinner")
            botonAceptar.textContent = "Enviando... "
            botonAceptar.insertBefore(i, null)
            botonAceptar.setAttribute("disabled", "true")

            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  > {nombreAccion}  </Button>
            )

        }
        else if (!subiendoDocumento && botonAceptar !== null && i_element !== null && filesEnviar.length > 0) {
            i_element.remove();
            botonAceptar.setAttribute("disabled", "false")

            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  > {nombreAccion} </Button>

            )
        }

        else if (!subiendoDocumento && filesEnviar.length > 0 ) {

            return (
                <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  > {nombreAccion} </Button>

            )
        }
        // //Este caso es en el caso de que seleccione documento de firma fisica
        // else if(stateModal.tipoFirma === "F"){
        //     return (
        //         <Button color="primary" id="botonAceptar" onClick={() => handleFirmar(objeto_pasando)}  > {nombreAccion} </Button>

        //     )
        // }
    }
        , [stateModal, props.extraData,tipoFirma])

    function handleFileUploadChange(archivo: FileInfo) {
        var uploadFile = new File([archivo.file], archivo.id + ".pdf");

        const src = window.URL.createObjectURL(uploadFile);

        const firmaArchivoInfo: FileInfoUrl = {
            nombreFile: archivo.nombreFile,
            file: uploadFile,
            id: archivo.id,
            url: src
        };

        setstateModalFirmar({
            ...stateModal,
            filesEnviar: [firmaArchivoInfo],
        })

    }

  

    const handleFirmar = useCallback(
        async (objetoFirmar: any) => {
            setstateModalFirmar({ ...stateModal, subiendoDocumento: true })
            if(tipoFirma === "E" && typeof(props.onClickSubirDocFirmaElectronica) === "function"){
                await props.onClickSubirDocFirmaElectronica(objetoFirmar);
            }
            else if(tipoFirma === "F" && typeof(props.onClickFirmaFisica) === "function"){
                await props.onClickFirmaFisica(objetoFirmar);
            }            
            setstateModalFirmar({ ...stateModal, subiendoDocumento: false })
        }
    ,[stateModal,tipoFirma])


    function CerrarModal() {
        setstateModalFirmar(stateInicial);
        if (props.soloTipoFirma !== undefined) {
            settipoFirma(props.soloTipoFirma);
        }
        else {
            settipoFirma(undefined);

        }
        
        props.onClose()
    }

    const BotonCancelar = useMemo(() => {
        return(
            <Button color="secondary" id="botonCancelar" disabled={stateModal.subiendoDocumento} onClick={() => CerrarModal()}>Cancelar</Button>
        )
    }, [stateModal,props])
    
    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={true}
            onClosed={() => CerrarModal()}
            contentClassName={props.contentClassName}
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal}</div>
            </ModalHeader>
            <ModalBody>
                {ContenidoModalBody}
            </ModalBody>
            <ModalFooter>

                {BotonFirmar}
                {BotonCancelar}
            </ModalFooter>
        </Modal>

    )



}
